export function getPhoneNumberInputPlaceholder(language) {
  switch (language) {
    case 'en':
      return 'Insert your phone number';
    case 'ru':
      return 'Вставьте свой номер телефона';
    case 'pl':
      return 'Wprowadź swój numer telefonu';
    case 'ua':
      return 'Введіть свій номер телефону';
    case 'cz':
      return 'Vložte své telefonní číslo';
    case 'by':
      return 'Увядзіце свой нумар тэлефона';
    case 'pt':
      return 'Insira seu número de telefone';
    case 'es':
      return 'Introduzca su número de teléfono';
    case 'ro':
      return 'Introduceți numărul dvs. de telefon';
    case 'bg':
      return 'Въведете телефонния си номер';
    case 'de':
      return 'Geben Sie Ihre Rufnummer ein';
    case 'fr':
      return 'Insérez votre numéro de téléphone';
    case 'nl':
      return 'Voer uw telefoonnummer in';
    case 'it':
      return 'Inserire il numero di telefono';
    case 'cn':
      return '输入电话号码';
    case 'ee':
      return 'Sisestage oma telefoninumber';
    case 'jp':
      return '電話番号を入力してください';
    case 'he':
      return 'הכנס את מספר הטלפון שלך';
    case 'ar':
      return 'أدخل رقم الهاتف';
    case 'tr':
      return 'Telefon numarası girin';
  }
}
